import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useProcessedBySelect } from './useProcessedBySelect';

interface ProcessedBySelectProps {
  onOpenPicker: () => void;
}

const ProcessedBySelect = ({ onOpenPicker }: Readonly<ProcessedBySelectProps>) => {
  const { t } = useTranslation();
  const select = useProcessedBySelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('conflict:processedBy')}
      placeholder={t('common:search')}
      searchPlaceholder={t('common:searchUsers')}
      onSearchIconClick={onOpenPicker}
      data-field="processedBy"
      data-testid="select-person-button"
    />
  );
};

export default ProcessedBySelect;
